import 'bootstrap-icons/font/bootstrap-icons.css';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './store/configureStore';
import App from './App';

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore();
store.runSaga();

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>)